(($) => {
    let $body;
    let $forms;

    let multiCountyZipCodes = ['94514', '95023', '95076', '95377', '95391'];

    $(document).on('ready', init);
    
    function init() {
        $body = $('body');
        $forms = $('form.zip-code-search-form');

        if ($forms.length == 0) {
            return false;
        }

        $forms.each(initForm);
    }

    function initForm(formIndex, formElement) {
        if (!formElement) {
            return false;
        }

        let $form = $(formElement);
        let $zipCodeInput = $form.find('input.zip-code');
        let $submitButton = $form.find('input[type="submit"]');
        let $modal = createModal();
        let $modalSelect = $modal.find('select');
        let $hiddenCountyField = createHiddenCountyField();

        bind();

        $form.addClass('initialized');

        function bind() {
            $zipCodeInput.on('keyup', onKeyUp);
            $modalSelect.on('change', onModalSelectChange);
            $form.on('submit', onFormSubmit);
        }

        function createModal() {
            return $(
                `<div class="modal county-select-modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body">
                                <select class="form__select w-100 w-sm-auto mb-1 mb-sm-0" name="county"></select>
                            </div>
                            <div class="modal-footer text-center">
                                <button type="button" class="btn btn-no-style" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>`);
        }

        function createHiddenCountyField() {
            return $('<input name="county" type="hidden">');
        }

        function getModalSelectOptions(zipCode) {
            if (!zipCode) {
                return '';
            }

            let options = '<option value="" selected>Please choose your county:</option>';

            options += (['94514', '95377', '95391'].indexOf(zipCode) == -1) ? '' : '<option value="Alameda">Alameda</option>';
            options += (['94514'].indexOf(zipCode) == -1) ? '' : '<option value="Contra Costa">Contra Costa</option>';
            options += (['95076'].indexOf(zipCode) == -1) ? '' : '<option value="Monterey">Monterey</option>';
            options += (['95023'].indexOf(zipCode) == -1) ? '' : '<option value="San Benito">San Benito</option>';
            options += (['95377', '95391'].indexOf(zipCode) == -1) ? '' : '<option value="San Joaquin">San Joaquin</option>';
            options += (['95023', '95076'].indexOf(zipCode) == -1) ? '' : '<option value="Santa Clara">Santa Clara</option>';
            options += (['95076'].indexOf(zipCode) == -1) ? '' : '<option value="Santa Cruz">Santa Cruz</option>';
            
            return options;
        }

        function isMultiCountyZipCode(zipCode) {
            if (multiCountyZipCodes.indexOf(zipCode) != -1) {
                return true;
            }

            return false;
        }

        function onKeyUp(event) {
            if (!event instanceof Event) {
                return false;
            }

            let filteredVal = $zipCodeInput.val().replace(/\D/g, '').slice(0, 5);
            $zipCodeInput.val(filteredVal);
        }

        function onModalSelectChange(event) {
            if (!event instanceof Event) {
                return false;
            }
            $hiddenCountyField.val($modalSelect.val());
            $form.get(0).submit();
        }

        function onFormSubmit(event) {
            if (!event instanceof Event) {
                return false;
            }

            let enteredZipCode = $zipCodeInput.val().trim();

            if (!isMultiCountyZipCode(enteredZipCode)) {
                $form.remove($hiddenCountyField);
                return true;
            }

            let countyValue = new FormData($form.get(0)).get('county');
            if (countyValue && countyValue != '') {
                return true;
            }

            event.preventDefault();
            
            $body.append($modal);
            $form.append($hiddenCountyField);
            $modalSelect.html(getModalSelectOptions(enteredZipCode));
            $modal.modal('show');

            return false;
        }
    }

})(jQuery);